import React, { useState } from "react";
import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { ISignup } from "../interfaces";

const SignupForm = ({
  signupInfo,
  handleChange,
}: {
  signupInfo: ISignup;
  handleChange(type: string, value: string): void;
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Grid
      container
      display="flex"
      flexDirection="row"
      spacing={4}
      justifyContent="center"
      alignItems="center"
      p={4}
    >
      <Grid
        container
        display="flex"
        flexDirection="column"
        spacing={2}
        justifyContent="center"
        size={{ xs: 12, md: 6 }}
      >
        <Typography fontWeight={600} fontSize={{ xs: 14, md: 18 }}>
          Información usuario
        </Typography>
        <TextField
          required
          size="small"
          placeholder="Nombre"
          fullWidth
          value={signupInfo.name}
          onChange={({ target: { value } }) => handleChange("name", value)}
        />
        <TextField
          size="small"
          required
          placeholder="Correo electronico"
          type="email"
          fullWidth
          value={signupInfo.email}
          onChange={({ target: { value } }) => handleChange("email", value)}
        />
        <FormControl fullWidth size="small">
          <OutlinedInput
            required
            type={showPassword ? "text" : "password"}
            placeholder="Ingresar contraseña"
            className="f-s-14"
            value={signupInfo.password}
            onChange={({ target: { value } }) =>
              handleChange("password", value)
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  <span className="material-symbols-rounded">
                    {showPassword ? "visibility" : "visibility_off"}
                  </span>
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Grid>

      <Grid
        container
        display="flex"
        flexDirection="column"
        spacing={2}
        justifyContent="center"
        size={{ xs: 12, md: 6 }}
      >
        <Typography fontWeight={600} fontSize={{ xs: 14, md: 18 }}>
          Información negocio
        </Typography>
        <TextField
          size="small"
          placeholder="Nombre"
          fullWidth
          required
          value={signupInfo.business_name}
          onChange={({ target: { value } }) =>
            handleChange("business_name", value)
          }
        />
        <TextField
          size="small"
          placeholder="Dirección"
          fullWidth
          required
          value={signupInfo.business_address}
          onChange={({ target: { value } }) =>
            handleChange("business_address", value)
          }
        />
        <TextField
          size="small"
          placeholder="Telefono"
          type="number"
          fullWidth
          value={signupInfo.business_phone}
          onChange={({ target: { value } }) =>
            handleChange("business_phone", value)
          }
        />
      </Grid>
    </Grid>
  );
};

export default SignupForm;
